module.exports = __webpack_public_path__ + "static/media/chevron_right.6e4c10c1.svg";